import { render } from "./MemberCard.vue?vue&type=template&id=0a8e3fa6&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"

import "./MemberCard.vue?vue&type=style&index=0&id=0a8e3fa6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8e3fa6"]])

export default __exports__